function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebChatWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.61,11.55H25v7.23a2,2,0,0,1-2,2.14H10.11v.34a2.33,2.33,0,0,0,2.3,2h9.84L26,25.47l-.55-2.21h.14a1.77,1.77,0,0,0,1.68-2v-8A1.53,1.53,0,0,0,25.61,11.55Z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.06,6.53H6.11C4.8,6.53,3.28,7.7,3.28,8.82v9.06c0,1,1.28,1.79,2.51,1.9l-.8,3,5.13-3H21.06c1.31,0,2.53-.8,2.53-1.92V8.82A2.58,2.58,0,0,0,21.06,6.53ZM8.39,14.18a1.35,1.35,0,1,1,1.35-1.35A1.34,1.34,0,0,1,8.39,14.18Zm5,0a1.35,1.35,0,1,1,1.35-1.35A1.34,1.34,0,0,1,13.44,14.18Zm5,0a1.35,1.35,0,1,1,1.35-1.35A1.34,1.34,0,0,1,18.49,14.18Z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebChatWhite);
export default __webpack_public_path__ + "static/media/web-chat-white.bb70e2c6.svg";
export { ForwardRef as ReactComponent };